const menuRouter = [
    /**
     * 销售管理
     **/
    {
        path: '/sale/salecostprice',
        meta: { title: '销售成本设置' },
        component: () => import('@/views/page/sale/salecostprice'),
        used: true,
    },
    {
        path: '/sale/commissionrate',
        meta: { title: '销售提成设置' },
        component: () => import('@/views/page/sale/commissionrate'),
        used: true,
    },
    {
        path: '/sale/salecontract',
        meta: { title: '销售合同' },
        component: () => import('@/views/page/sale/salecontract'),
        used: true,
    },
    {
        path: '/sale/saleorder',
        meta: { title: '销售订单' },
        component: () => import('@/views/page/sale/saleorder'),
        used: true,
    },
    {
        path: '/sale/saledelivery',
        meta: { title: '销售送货' },
        component: () => import('@/views/page/sale/saledelivery'),
        used: true,
    },
    {
        path: '/sale/salegift',
        meta: { title: '销售赠送' },
        component: () => import('@/views/page/sale/salegift'),
        used: true,
    },
    {
        path: '/sale/salereturn',
        meta: { title: '销售退货' },
        component: () => import('@/views/page/sale/salereturn'),
        used: true,
    },
    {
        path: '/sale/saleinvoice',
        meta: { title: '销售发票' },
        component: () => import('@/views/page/sale/saleinvoice'),
        used: true,
    },
    {
        path: '/sale/saleorderexpire',
        meta: { title: '过期订单' },
        component: () => import('@/views/page/sale/saleorderexpire'),
        used: true,
    },
    {
        path: '/sale/salepriceanal',
        meta: { title: '销售价格分析' },
        component: () => import('@/views/page/sale/salepriceanal'),
        used: true,
    },
    {
        path: '/sale/saleanalysis',
        meta: { title: '销售分析' },
        component: () => import('@/views/page/sale/saleanalysis'),
        used: true,
    },
    {
        path: '/sale/saleorderdetailed',
        meta: { title: '销售订单明细表' },
        component: () => import('@/views/page/sale/saleorderdetailed'),
        used: true,
    },
    {
        path: '/sale/saledetailed',
        meta: { title: '销售明细表' },
        component: () => import('@/views/page/sale/saledetailed'),
        used: true,
    },
    {
        path: '/sale/profitstatistics',
        meta: { title: '利润分析表(综合)' },
        component: () => import('@/views/page/sale/profitstatistics'),
        used: true,
    },
    {
        path: '/sale/profitstatisdetailed',
        meta: { title: '利润分析表(明细)' },
        component: () => import('@/views/page/sale/profitstatisdetailed'),
        used: true,
    },
    {
        path: '/sale/profitstatisbysalesman',
        meta: { title: '利润分析表(业务员)' },
        component: () => import('@/views/page/sale/profitstatisbysalesman'),
        used: true,
    },
    {
        path: '/sale/profitstatisbyproduct',
        meta: { title: '利润分析表(商品)' },
        component: () => import('@/views/page/sale/profitstatisbyproduct'),
        used: true,
    },
    {
        path: '/sale/profitstatisbycollection',
        meta: { title: '利润分析表(回款)' },
        component: () => import('@/views/page/sale/profitstatisbycollection'),
        used: true,
    },
]

export default menuRouter
